import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    orderTabSearch : '',
    transportTabSearch : '',
    agentId: '',
    receiveOrder: {
        offset: 0,
        limit: 10,
        start_date: null,
        end_date: null,
    },
    waitingSend: {
        offset: 0,
        limit: 10,
    },
    processDelivery: {
        startDate: null,
        endDate: null,
        wording: '',
        offset: 0,
        limit: 10,
    }, 
    completeOrder: {
        offset: 0,
        limit: 10,
    },
    cancelOrder: {
        offset: 0,
        limit: 10,
    },
    dataNewOrders: {
        offset: 0,
        limit: 10,
    },
    dataPrepareShip: {
        offset: 0,
        limit: 10,
    },
    dataShipped: {
        offset: 0,
        limit: 10,
    },
    dataComplete: {
        offset: 0,
        limit: 10,
    },
    dataCancel: {
        offset: 0,
        limit: 10,
    },
    dataCredit: {
        offset: 0,
        limit: 10,
    },
    dataPrepareShipped: {
        offset: 0,
        limit: 10,       
    },
    dataTransportShipped: {
        offset: 0,
        limit: 10,          
    },
    dataTransportSuccess: {
        offset: 0,
        limit: 10,    
    },
    tabSelected: '0',
    reload: false,
    lastDate: '',
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setAgentId: (state, action) => {
            state.agentId = action.payload;
        },
        setOrderTabSearcht: (state, action) => {
            state.orderTabSearch = action.payload;
        },
        settransportTabSearch: (state, action) => {
            state.transportTabSearch = action.payload;
        },
        setReceiveOrderOffset: (state, action) => {
            state.receiveOrder.offset = action.payload;
        },
        setReceiveOrderLimit: (state, action) => {
            state.receiveOrder.limit = action.payload;
        },
        setReceiveOrderStartDate: (state, action) => {
            state.receiveOrder.start_date = action.payload;
        },
        setReceiveOrderEndDate: (state, action) => {
            state.receiveOrder.end_date = action.payload;
        },
        setWaitingSendOffset: (state, action) => {
            state.waitingSend.offset = action.payload;
        },
        setWaitingSendLimit: (state, action) => {
            state.waitingSend.limit = action.payload;
        },
        setProcessDeliveryStartDate: (state, action) => {
            state.processDelivery.startDate = action.payload;
        },
        setProcessDeliveryEndDate: (state, action) => {
            state.processDelivery.endDate = action.payload;
        },
        setProcessDeliveryWording: (state, action) => {
            state.processDelivery.wording = action.payload;
        },
        setProcessDeliveryOffset: (state, action) => {
            state.processDelivery.offset = action.payload;
        },
        setProcessDeliveryLimit: (state, action) => {
            state.processDelivery.limit = action.payload;
        },
        setCompleteOrderOffset: (state, action) => {
            state.completeOrder.offset = action.payload;
        },
        setCompleteOrderLimit: (state, action) => {
            state.completeOrder.limit = action.payload;
        },
        setCancelOrderOffset: (state, action) => {
            state.cancelOrder.offset = action.payload;
        },
        setCancelOrderLimit: (state, action) => {
            state.cancelOrder.limit = action.payload;
        },
        setTabSelected: (state, action) => {
            state.tabSelected = action.payload;
        },
        setDataNewOrdersLimit: (state, action) => {
            state.dataNewOrders.limit = action.payload;
        },
        setDataNewOrdersOffset: (state, action) => {
            state.dataNewOrders.offset = action.payload;
        },
        setDataPrepareShipLimit: (state, action) => {
            state.dataPrepareShip.limit = action.payload;
        },
        setDataPrepareShipOffset: (state, action) => {
            state.dataPrepareShip.offset = action.payload;
        },
        setDataShippedLimit: (state, action) => {
            state.dataShipped.limit = action.payload;
        },
        setDataShippedOffset: (state, action) => {
            state.dataShipped.offset = action.payload;
        },
        
        setDataCompleteLimit: (state, action) => {
            state.dataComplete.limit = action.payload;
        },
        setDataCompleteOffset: (state, action) => {
            state.dataComplete.offset = action.payload;
        },
        
        setDataCancelLimit: (state, action) => {
            state.dataCancel.limit = action.payload;
        },
        setDataCancelOffset: (state, action) => {
            state.dataCancel.offset = action.payload;
        },
    
        setDataCreditLimit: (state, action) => {
            state.dataCredit.limit = action.payload;
        },
        setDataCreditOffset: (state, action) => {
            state.dataCredit.offset = action.payload;
        },

        setDataPrepareShippedLimit: (state, action) => {
            state.dataPrepareShipped.limit = action.payload;
        },
        setDataPrepareShippedOffset: (state, action) => {
            state.dataPrepareShipped.offset = action.payload;
        },

        setDataTransportShippedLimit: (state, action) => {
            state.dataTransportShipped.limit = action.payload;
        },
        setDataTransportShippedOffset: (state, action) => {
            state.dataTransportShipped.offset = action.payload;
        },

        setDataTransportSuccessLimit: (state, action) => {
            state.dataTransportSuccess.limit = action.payload;
        },
        setDataTransportSuccessOffset: (state, action) => {
            state.dataTransportSuccess.offset = action.payload;
        },
        setReload: (state, action) => {
            state.reload = action.payload;
        },
        setLastDate: (state, action) => {
            state.lastDate = action.payload;
        },
        reset: (state) => {
            return initialState;
        },

    },
});

export const {
    setAgentId,
    setReceiveOrderOffset,
    setReceiveOrderLimit,
    setReceiveOrderStartDate,
    setReceiveOrderEndDate,
    setWaitingSendOffset,
    setWaitingSendLimit,
    setProcessDeliveryStartDate,
    setProcessDeliveryEndDate,
    setProcessDeliveryWording,
    setProcessDeliveryOffset,
    setProcessDeliveryLimit,
    setCompleteOrderOffset,
    setCompleteOrderLimit,
    setCancelOrderOffset,
    setCancelOrderLimit,
    setTabSelected,
    setDataNewOrdersLimit,
    setDataNewOrdersOffset,
    setDataPrepareShipLimit,
    setDataPrepareShipOffset,
    setDataShippedLimit,
    setDataShippedOffset,
    setDataCompleteLimit,
    setDataCompleteOffset,
    setDataCancelLimit,
    setDataCancelOffset,
    setDataPrepareShippedLimit,
    setDataPrepareShippedOffset,
    setDataTransportShippedLimit,
    setDataTransportShippedOffset,
    setDataTransportSuccessLimit,
    setDataTransportSuccessOffset,
    setDataCreditLimit,
    setDataCreditOffset,
    setReload,
    setLastDate,
    reset
} = orderSlice.actions;

export default orderSlice.reducer;